import script from "./RenewalManagementView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RenewalManagementView.vue?vue&type=script&setup=true&lang=ts"

import "./RenewalManagementView.vue?vue&type=style&index=0&id=957c7252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-957c7252"]])

export default __exports__